// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"645":"8035fbdb","649":"641de620"}[chunkId] + ".chunk.css";
};